import React from "react";

import { Products } from "../Products";

export const Dashboard = () => {
  return (
    <React.Fragment>
      <Products />
    </React.Fragment>
  );
};
